<template>
  <div class="toast">
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
  },
};
</script>

<style lang="scss" >
.toast {
  background: rgba(0, 0, 0, 0.67);
  color: #fff;
  border-radius: 4px;
  padding: 11px 28px;
  max-width: 280px;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  position: fixed;
  font-size: 16px;
  line-height: 16px;
  top: 40%;
  left: 50%;
  z-index: 2001;
  animation: fade-up 0.3s linear both;
}

@keyframes fade-up {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(100%);
  }

  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/toast/index.vue